import { render, staticRenderFns } from "./TabCardKpi.vue?vue&type=template&id=4c367c72&scoped=true&"
import script from "./TabCardKpi.vue?vue&type=script&lang=js&"
export * from "./TabCardKpi.vue?vue&type=script&lang=js&"
import style0 from "./TabCardKpi.vue?vue&type=style&index=0&id=4c367c72&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c367c72",
  null
  
)

export default component.exports